import React from 'react';
import { FormStatistics } from '../../types/Form';

interface FormStatsCardsProps {
  statistics: FormStatistics;
  /** Optional title above the grid */
  title?: string;
}

/**
 * Presentational stats cards for form/submission statistics.
 * Used in FormDetailModal and anywhere overview stats are shown.
 */
const FormStatsCards: React.FC<FormStatsCardsProps> = ({ statistics, title = 'Statistics' }) => {
  const items = [
    { label: 'Total Submissions', value: statistics.totalSubmissions },
    { label: 'Pending', value: statistics.pendingSubmissions },
    { label: 'Processed', value: statistics.processedSubmissions },
    { label: 'Last 30 Days', value: statistics.submissionsLast30Days }
  ];
  if (statistics.submissionsLast7Days !== undefined) {
    items.push({ label: 'Last 7 Days', value: statistics.submissionsLast7Days });
  }

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h4 className="text-sm font-medium text-gray-900 mb-3">{title}</h4>
      <div className="grid grid-cols-2 gap-4">
        {items.map(({ label, value }) => (
          <div key={label}>
            <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{label}</label>
            <p className="text-sm text-gray-900">{value ?? 0}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormStatsCards;
